import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, FormGroup, FormControl } from 'react-bootstrap';
import DealContext from '../DealContext';
import ApiService from '../../../services/ApiService';
import toastr from '../../toastr';

const BranchCard = () => {
  const { deal, fetchDeal } = useContext(DealContext);
  const { user } = useSelector(state => state.app);

  const [selectedBranch, setSelectedBranch] = useState(deal.branchId);

  const handleChange = event => {
    setSelectedBranch(event.target.value);

    const branch = user.branches.find(b => b.id === Number(event.target.value));

    return ApiService.put(`crm/deal/${String(deal.id)}/change-branch`, { branchId: branch.id }).then(() => {
      toastr.success('Deal Updated', `Branch changed to ${branch.name}`);
      fetchDeal();
    });
  };

  return (
    <Card>
      <Card.Body>
        <Card.Title>Branch</Card.Title>
        <FormGroup className="form-select">
          <FormControl onChange={handleChange} as="select" value={selectedBranch}>
            {user.branches.map(branch => (
              <option key={branch.id} value={branch.id}>
                {branch.name}
              </option>
            ))}
          </FormControl>
        </FormGroup>
      </Card.Body>
    </Card>
  );
};

export default BranchCard;
